import React from 'react';
import { connect } from 'react-redux';
import { hideHand } from '../../../actions';

const Hand = ({ dispatch, displayHand }) => displayHand ? (
    <div className="hand" style={{ top: window.innerHeight/2 - 241/2, left: window.innerWidth/2 - 224/2 }} onTouchStart={ e => dispatch(hideHand()) } onMouseEnter={ e => dispatch(hideHand()) } >
        <img src="kozySlider/images/hand_icon.png" alt="help hand" />
    </div>
) : null

export { Hand };

export default connect(
    (state) => state.app
)(Hand);



// WEBPACK FOOTER //
// ./src/components/360Mode/AppartmentView/Hand.js